import ErrorOutlined from '@icons/ErrorOutlined';
import InfoOutlined from '@icons/InfoOutlined';
import WarningOutlined from '@icons/WarningOutlined';
import { Alert, useTheme } from '@mui/material';
import { memo, useState } from 'react';
import { useGetMOTDQuery } from './service';

const MaintenanceBanner = () => {
  const theme = useTheme();

  const { currentData: motd } = useGetMOTDQuery();
  const [dismissed, setDismissed] = useState(false);

  // Only show banner if displayType is 'banner' and not dismissed
  if (!motd || motd.displayType !== 'banner' || dismissed) {
    return null;
  }

  const getSeverity = () => {
    switch (motd.level) {
      case 'error':
        return 'error';
      case 'warn':
        return 'warning';
      case 'info':
      default:
        return 'info';
    }
  };

  const getIcon = () => {
    switch (motd.level) {
      case 'error':
        return <ErrorOutlined fontSize="medium" />;
      case 'warn':
        return <WarningOutlined fontSize="medium" />;
      case 'info':
      default:
        return <InfoOutlined fontSize="medium" />;
    }
  };

  return (
    <Alert
      severity={getSeverity()}
      icon={getIcon()}
      onClose={() => setDismissed(true)}
      slotProps={{
        closeButton: {
          sx: {
            padding: 1
          }
        },
        closeIcon: {
          fontSize: 'medium'
        }
      }}
      sx={{
        borderRadius: 0,
        padding: theme.spacing(1, 2),
        alignItems: 'center',
        gap: 2,
        '& .MuiAlert-icon': {
          padding: 0,
          height: 'fit-content',
          marginRight: 0
        },
        '& .MuiAlert-message': {
          padding: 0,
          alignContent: 'center',
          flex: 1,
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 600,
          lineHeight: '150%',
          letterSpacing: '0.15px'
        },
        '& .MuiAlert-action': {
          padding: 0
        }
      }}
    >
      {motd.message}
    </Alert>
  );
};

export default memo(MaintenanceBanner);
